const prefix = 'ndi:table:v1:'

export function readTablePreferences (key) {
  if (!key) return []
  try {
    const columns = JSON.parse(localStorage.getItem(prefix + key))
    return Array.isArray(columns) ? columns : []
  } catch (_) {
    return []
  }
}

export function writeTablePreferences (key, columns) {
  if (key) localStorage.setItem(prefix + key, JSON.stringify(columns))
}
